<main class="main--header">
  <router-outlet />
</main>

<app-nav *ngIf="isShowNavbar$ | async" />
